<template>
  <div id="userLogin">
    <div class="big-img"></div>
    <form class="dataFrom">
      <div class="vant-input">
        <keep-alive>
          <se-autocomplete :loginLog="loginLog" v-model="iccid" :fetchsuggestions="querySearch" @select="handleSelect"
            placeholder="请输入卡号/手机号"></se-autocomplete>
        </keep-alive>
      </div>
      <div class="formLine">
        <mt-button type="primary" size="large" @click.prevent="userQuerySIM">查询</mt-button>
      </div>
      <van-notice-bar color="#848484" background="#FFFFFF" left-icon="volume-o" :text="homeTitle"
        :style="{ borderRadius: '10px', width: '94%', padding: '6', margin: '10px auto 20px auto', fontSize: '16px', fontWeight: 'bold' }"
        mode="link" class="vant-notice1"></van-notice-bar>
    </form>
    <div class="more-dialog" v-if="isDialogShow">
      <div class="more-bg"></div>
      <div class="more-list">
        <div class="more-title">选择登录卡号</div>
        <div class="more-list-flex">
          <template v-for="(item, index) in phoneList">
            <div class="more-list-item" :key="index" @click="selectIon(item, index)"
              :class="{ 'active': index === inx }">
              <img src="@/assets/img/2.png" alt="" v-if="item.poolName === '联通'">
              <img src="@/assets/img/3.png" alt="" v-else-if="item.poolName === '移动'">
              <img src="@/assets/img/4.png" alt="" v-else-if="item.poolName === '电信'">
              <img src="@/assets/img/1.png" alt="" v-else>
              <div class="num">{{ item.cardNo }}</div>
            </div>
          </template>
        </div>
        <div class="dialog-btn">
          <div class="close" @click="isDialogShow = false">取消</div>
          <div class="corm" @click="userQuerySIM">确定</div>
        </div>
      </div>
    </div>

    <img v-if="isShowImg" :src="loginImg" @click="toUrl" alt="" style="margin-top: 200px; width: 100%;">
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  components: { SeAutocomplete, Advertisement },
  data() {
    return {
      loginLog: [], //历史记录的卡号
      phoneList: [], //手机绑定的卡号
      isOpenid: 0,
      iccid: "",
      code: "",
      showAds: true,
      gzh: "",
      homeTitle: '',
      realNameList: [
        "1192351241053663232",
        "1224969664338063360",
        "1255666672321163264",
        "7DA692EC992B45E297450F40DEDC5614",
        "8601954A2B074E80AACAAF32C5EE232C",
        "960F3276EFAA4ED2999754895F4BCCB4",
        "B1E112B9F1D8420E9072D9F47D6A135E",
        "1275705014286807040",
        "1275706083402313728",
        "1274979554988912640",
        "1279289937396494336",
      ],
      isDialogShow: false,
      dialogIccid: '',
      inx: null,
      suolangList: ["1275704520822747136"],

      loginImg: '',
      loginUrl: '',
      isShowImg: false,
    };
  },
  methods: {
    toUrl() {
      if (this.loginUrl) {
        window.location.href = this.loginUrl;
      }
    },

    selectIon(item, index) {
      this.inx = index
      this.dialogIccid = item.cardNo
    },
    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData("iccidList");
      var results = queryString ? listAll.filter(this.createFilter(queryString)) : listAll;
      cb(results);
    },
    createFilter(queryString) {
      return (listAll) => {
        return listAll.indexOf(queryString) == 0;
      };
    },
    handleSelect(item) {
      this.iccid = item;
    },
    userQuerySIM() {
      if (!this.iccid || this.iccid.length < 3 && !this.isDialogShow) {
        Dialog.alert({ title: "提示", message: "请输入正确卡号" });
        return false;
      }
      let recordLoginText = this.iccid; //存放用户登录时输入的文本，将用于首页显示

      let data = {
        requestId: this.dialogIccid ? this.dialogIccid : this.iccid,
        code: this.code,
        isOpenid: this.isOpenid
      };
      var wxOpenId = localStorage.getItem('wxOpenId');
      if (wxOpenId) {
        data.code = wxOpenId;
        data.isOpenid = 1;
      }
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          this.isDialogShow = false
          let record = res.data.data;
          let iccid = record.iccid;
          if (record.titleMap) {
            localStorage.setItem("wxTitle", record.titleMap.title);
            localStorage.setItem("wxText", record.titleMap.context);
            localStorage.setItem("wxUrls", record.titleMap.urls);
          } else {
            localStorage.setItem("wxTitle", '');
            localStorage.setItem("wxText", '');
            localStorage.setItem("wxUrls", '');
          }
          localStorage.setItem('loginHtml', 1);
          localStorage.setItem('newHomeImg', record.newHomeImg);
          localStorage.setItem('newHomeImg2', record.newHomeImg2);
          localStorage.setItem('newHomeUrl', record.newHomeUrl);
          localStorage.setItem('isNewPage', record.isNewPage);
          this.$store.state.isNewPage = record.isNewPage;
          localStorage.setItem("isBindPhone", record.isBindPhone);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("iccid", iccid);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("phoneNo", record.userPhone);
          localStorage.setItem("userPhone", record.userPhone);
          localStorage.setItem("openId", record.openId);
          localStorage.setItem("agentId", record.agentId);
          localStorage.setItem("flowRatePool", record.flowRatePool);
          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.state.flowRatePool = res.data.data.flowRatePool;

          this.$store.state.intoNo = record.intoNo;
          this.setAutoCompleteData("iccidList", recordLoginText, 10);

          if (record.isToGroupChange == 1) {
            localStorage.setItem("allChangeList", window.btoa(unescape(encodeURIComponent(JSON.stringify(record.allChangeList)))));
            localStorage.setItem("nowGroup", record.basePkgGroup);
            this.$router.replace('/userNew/changeGroup');
          } else if (record.isToYuCun != 1) {
            this.$router.replace("/user/openPrice");
          } else {
            let _data = { iccid: record.iccid };
            wxRequest("bindPhone/state", _data, "post").then((res) => {
              if (res.data.code == 200) {
                let result = res.data.data;
                localStorage.setItem(
                  "applyChangeSimState",
                  result.applyChangeSimState
                );
                if (result.bindState == 2) {
                  this.$router.push({
                    path: "/userNew/bindPhone",
                    query: {
                      iccid: record.iccid,
                    },
                  });
                } else {
                  if (record.isNewPage == 0) {
                    this.$router.replace('/user/home');
                  } else if (record.isNewPage == 1) {
                    this.$router.replace('/userNew/home');
                  } else if (record.isNewPage == 2) {
                    this.$router.replace('/user/homeNew');
                  } else if (record.isNewPage == 3) {
                    this.$router.replace('/new/home');
                  }
                }
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }
        } else if (res.data.code == 666) { //此时要弹出手机绑定列表，让用户来选择登录的卡号。 用户选择完卡号之后  继续请求 userQuerySIM 方法
          this.phoneList = res.data.data; // cardNo 表示展示的卡号。 poolName 表示类型
          this.isDialogShow = true
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    goBuyCard() {
      window.location.href = "http://czlj.wzyw.cc/#/user/login2";
    },

    // goto(path){
    //     //广告点击统计
    //     wxRequest("link/click",{url: path}, "get").then(res => {
    //         window.location.href = path;
    //     });

    // },
  },
  async created() {
    var source = this.getQueryVariable("source") ? this.getQueryVariable("source") : process.env.VUE_APP_APPID;
    this.dialogIccid = ''
    var appid = source ? source : process.env.VUE_APP_APPID;
    await wxRequest("sim/get/login/remark", {}, "post").then((res) => {
      this.homeTitle = res.data.data.loginRemark;
      if (res.data.data.loginImg && res.data.data.loginImg.length > 5) {
        this.loginImg = "http://czlj.wzyw.cc:8888/" + res.data.data.loginImg;
        this.loginUrl = res.data.data.loginUrl;
        this.isShowImg = true;
      }
    })


    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
    }

    await wxRequest("/sim/get/appId", {}, "get").then((res) => {
      if (res.data.code == 200) {
        appid = res.data.data;
        var oldAppid = localStorage.getItem("appid");
        if (oldAppid && oldAppid.length > 5 && oldAppid != appid) {
          localStorage.removeItem('wxOpenId');
        }
      }
    });
    await wxRequest("sim/get/pay/state", { iccid: localStorage.getItem("iccid") }, "post").then((res) => {
      if (res.data.code == 200) {
        localStorage.setItem("leshuaPay", 1);
      } else {
        localStorage.setItem("leshuaPay", 2);
      }
    });
    localStorage.setItem("appid", appid);
    localStorage.setItem("isHeadquarterAppid", true);
    this.$store.commit("setIsHeadquarterAppid", "true");


    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
    }

    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
      if (this.$route.query.iccid) {
        this.iccid = this.$route.query.iccid;
      } else {
        this.iccid = localStorage.getItem("recordLoginText");
      }
      //使用code 去获取openId
      let data = {
        code: this.code,
        isOpenid: 0
      };
      //判断是缓存是否存在openid， 存在的话 就不要获取了
      var wxOpenId = localStorage.getItem('wxOpenId');
      if (wxOpenId) {
        data.isOpenid = 1;
        data.code = wxOpenId;
      }
      await wxRequest("sim/get/openid", data, "get").then((res) => {
        if (res.data.code == 200) {
          this.code = res.data.data.openid;
          this.loginLog = res.data.data.cardList; //获取用户的绑定列表
          this.isOpenid = 1;
          localStorage.setItem('wxOpenId', res.data.data.openid);
          if (this.$route.query.iccid) {
            this.iccid = this.$route.query.iccid;
            this.userQuerySIM();
          }

        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      })

    }



  },

  mounted() { },

  beforeDestory() { },
};
</script>


<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
}

.more-dialog {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10001;

  .more-bg {
    background: rgba(0, 0, 0, .3);
    width: 100%;
    height: 100%;
  }

  .more-list {
    width: 90%;
    height: 400px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    top: 0;
    left: 0;
    margin: auto;
    bottom: 0;
    right: 0;

    .more-title {
      text-align: center;
      font-size: 19px;
      border-radius: 14px;
      font-weight: 600;
      color: #222222;
      height: 51px;
      padding-top: 22px;
      background: linear-gradient(180deg, #DAE8FF 0%, rgba(255, 255, 255, 0) 100%);
    }

    .more-list-flex {
      overflow: auto;
      height: 220px;
    }

    .more-list-item {
      display: flex;
      height: 60px;
      width: 85%;
      margin: 0 auto 8px;
      border: 1px solid #EEF4FF;
      align-items: center;

      img {
        width: 65px;
        height: 18px;
        margin-left: 10px;
        margin-right: 20px;
      }

      .num {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #94959A;
        line-height: 20px;
      }
    }

    .active {
      border: 1px solid #1772FF;
    }

    .dialog-btn {
      display: flex;
      position: absolute;
      bottom: 18px;
      width: 100%;
      height: 40px;
      justify-content: space-around;

      .close {
        width: 121px;
        height: 44px;
        background: #F5F5F5;
        border-radius: 7px;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        line-height: 44px;
      }

      .corm {
        width: 121px;
        height: 44px;
        background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
        border-radius: 7px;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        text-align: center;
        line-height: 44px;
      }
    }
  }

}

#userLogin {
  padding: 0;
  position: relative;

  .tip {
    width: 88%;
    margin: 120px auto;

    .title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      margin-bottom: 10px;
    }

    .tip-content {
      font-size: 12px;
      color: #999;
      line-height: 20px;
      margin-bottom: 4px;
    }
  }

  .big-img {
    width: 100%;
    height: 263px;
    border-radius: 0;
    background: url(../../assets/home/icon17.png) no-repeat center top;
    background-size: 100%;
  }

  .dataFrom {
    width: 80%;
    margin: 0 auto;
    position: absolute;
    top: 11.875rem;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border-radius: 10px;
    text-align: center;
    padding: 20px;
    box-shadow: 0px 4px 10px 0px #daecff;
    height: 180px;
    box-sizing: initial;
    
    button {
      width: 100%;
      line-height: 46px;
      border-radius: 40px;
      font-size: 14px;
      height: 56px;
      background: #455ef1;
      border: 0px solid #282e3e;
      margin: 0 auto;
    }
  }

  .vant-input {
    /deep/ input[type="text"] {
      background: #efefef;
      border-color: #efefef;
      border-radius: 40px;
      color: #999;
      text-align: center;
      width: 100%;
      height: 56px;
      margin: 0 auto;
      margin-bottom: 14px;
    }

    // /deep/ input[type=text]::-webkit-input-placeholder {
    // 	font-size: 12px;
    // 	text-align: center;
    // }
  }
}

.tabClick {
  color: #f44034;
  font-size: 1rem;
  position: absolute;
  bottom: 10%;
  left: 0;
  right: 0;
  text-align: center;
  margin: auto;
}

.formLine {
  .mint-button--primary {
    background: #24bac8;
    border-radius: 20px;
    height: 44px;
  }
}

// h2 {
//     display: flex;
//     align-items: center;
//     .yema-img {
//         height: 20px;
//         padding-right: 3px;
//     }
// }</style>